import { render } from "./BMediaAside.vue?vue&type=template&id=8d9f6da6"
import script from "./BMediaAside.vue?vue&type=script&lang=js"
export * from "./BMediaAside.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__